export enum EPatientType {
  AL = 'AL',
  IL = 'IL',
  MC = 'MC',
  UNKNOWN = 'UNKNOWN',
  EMPLOYEE = 'EMPLOYEE',
  OTHER = 'OTHER',
}
